<template>
  <div class="flex justify-end w-full space-x-6 text-md">
    <button
      @click="handleClear"
      class="font-bold px-14 py-2 rounded-md text-zinc-950 border border-gray-200 focus:outline-hidden"
    >
      Clear
    </button>
    <button
      @click="handleClose"
      class="px-10 text-white bg-blackest hover:bg-blackest focus:bg-blackest focus:outline-hidden active:bg-blackest active:outline-hidden rounded-md"
    >
      Show Art
    </button>
  </div>
</template>

<script setup>
defineProps({
  handleClear: {
    type: Function,
    required: true,
  },
  handleClose: {
    type: Function,
    required: true,
  },
})
</script>

<script>
export default {
  name: "MobileFooter",
}
</script>
